export default "__VITE_ASSET__De5PTxDH__"